module.exports = __webpack_public_path__ + "img/tryAgainButton.375fac95.png";